import { createSelector } from 'reselect';
import { initialState } from './reducer';

/**
 * Direct selector to the attendance state domain
 */

const selectAttendanceDomain = state => state.attendance || initialState;

/**
 * Other specific selectors
 */

/**
 * Default selector used by Attendance
 */

const makeSelectId = () =>
  createSelector(
    selectAttendanceDomain,
    substate => substate.id,
  );

const makeSelectFirstRender = () =>
  createSelector(
    selectAttendanceDomain,
    substate => substate.firstRender,
  );

const makeSelectItemsList = () =>
  createSelector(
    selectAttendanceDomain,
    substate => substate.itemsList,
  );


const makeSelectCourse = () =>
  createSelector(
    selectAttendanceDomain,
    substate => substate.courseDetail,
  );

const makeSelectLoading = () =>
  createSelector(
    selectAttendanceDomain,
    substate => substate.loading,
  );

const makeSelectLoadingCourse = () =>
  createSelector(
    selectAttendanceDomain,
    substate => substate.loadingCourse,
  );

const makeSelectLoadingUpdates = () =>
  createSelector(
    selectAttendanceDomain,
    substate => substate.loadingUpdates,
  );

const makeSelectError = () =>
  createSelector(
    selectAttendanceDomain,
    substate => substate.error,
  );

const selectAttendanceDeleteSuccessful = () =>
  createSelector(
    selectAttendanceDomain,
    substate => substate.deleteSuccessful,
  );

export {
  selectAttendanceDomain,
  makeSelectLoading,
  makeSelectError,
  makeSelectItemsList,
  makeSelectCourse,
  makeSelectLoadingUpdates,
  makeSelectLoadingCourse
};
